import useActiveProfile from './useActiveProfile';
import usePartnerProfile from './usePartnerProfile';

/*
 * This hook checks if the user needs to renew the Powered By Zapier terms.
 *
 * Be mindful that this hook uses usePartnerProfile which needs to be wraapped
 * in a <PartnerProfileProvider> component.
 */
function usePoweredByZapierTos() {
  const {
    activeProfile,
    isLoading: isLoadingActiveProfile,
  } = useActiveProfile();
  const isMasquerading = activeProfile?.isMasquerading ?? false;
  const isDeveloper = activeProfile?.isDeveloper ?? false;
  const {
    isLoading: isLoadingPartnerProfile,
    partnerProfile,
    updatePartnerProfile,
  } = usePartnerProfile();
  const shouldRenewPbZTos = partnerProfile?.shouldRenewPbZTos ?? false;

  const isLoading = isLoadingActiveProfile || isLoadingPartnerProfile;

  const renew = async () =>
    updatePartnerProfile({
      ...partnerProfile,
      pbzTosAgreement: true,
      shouldRenewPbZTos: false,
    });

  const shouldRenew =
    !isLoading && !isMasquerading && isDeveloper && shouldRenewPbZTos;

  return { isLoading, renew, shouldRenew };
}

export default usePoweredByZapierTos;
